import {
  get_headers,
  get_project_id,
} from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import report_builder_columns_step from "./ReportBuilderColumnsStep.vue";
import report_builder_data_selection_step from "./ReportBuilderDataSelectionStep.vue";
import report_builder_review_step from "./ReportBuilderReviewStep.vue";
import report_generation_builder_computed from "./report_generation_builder_computed";
import report_generation_builder_core_methods from "./report_generation_builder_core_methods";
import report_generation_builder_loading_methods from "./report_generation_builder_loading_methods";
import report_generation_builder_selection_methods from "./report_generation_builder_selection_methods";
import report_generation_builder_step_computed from "./report_generation_builder_step_computed";
import report_generation_builder_step_methods from "./report_generation_builder_step_methods";
import report_generation_builder_submission_methods from "./report_generation_builder_submission_methods";

const build_lookup_state = () => ({
  report_types: [],
  scope_types: [],
  output_formats: [],
  date_dimensions: [],
  report_fields: [],
  report_metric_types: [],
  filter_types: [],
  entity_types: [],
  section_questions: [],
});

/**
 * Main report builder component configuration.
 */
export default {
  name: "ReportGenerationBuilder",
  components: {
    ReportBuilderColumnsStep: report_builder_columns_step,
    ReportBuilderDataSelectionStep: report_builder_data_selection_step,
    ReportBuilderReviewStep: report_builder_review_step,
  },
  mixins: [alert_mixin],
  props: {
    initial_target_entity_profile_id: { type: [Number, String], default: null },
    initial_entity_type_id: { type: [Number, String], default: null },
    initial_entity_name: { type: String, default: "" },
  },
  data: () => ({
    headers: get_headers(),
    project_id: get_project_id(),
    loading_lookups: false,
    loading_forms: false,
    loading_main_sections: false,
    loading_sub_sections: false,
    loading_questions: false,
    loading_template: false,
    generating_report: false,
    editing_template_id: null,
    builder_view_mode: "guided",
    current_step_key: "basics",
    save_as_template: false,
    template_name: "",
    template_description: "",
    selected_report_type_id: "",
    selected_output_format_id: "",
    selected_date_dimension_id: "",
    selected_date_from: "",
    selected_date_to: "",
    selected_field_ids: [],
    field_display_labels: {},
    selected_entity_type_ids: [],
    use_project_scope: true,
    available_forms: [],
    main_sections: [],
    sub_sections: [],
    question_list: [],
    selected_form_id: "",
    selected_main_section_id: "",
    selected_sub_section_id: "",
    question_search: "",
    selected_questions: [],
    generated_report: null,
    lookup_data: build_lookup_state(),
  }),
  watch: {
    use_project_scope() {
      this.handle_scope_change();
    },
    selected_report_type_id() {
      this.handle_report_type_change();
    },
    "$route.query.template_id"() {
      if (this.lookup_data.report_types.length && this.get_route_template_id()) {
        this.load_template();
      }
    },
  },
  computed: {
    ...report_generation_builder_computed,
    ...report_generation_builder_step_computed,
  },
  mounted() {
    this.initialize_builder_view_mode();
    this.load_lookups();
  },
  methods: {
    ...report_generation_builder_core_methods,
    ...report_generation_builder_loading_methods,
    ...report_generation_builder_selection_methods,
    ...report_generation_builder_step_methods,
    ...report_generation_builder_submission_methods,
  },
};
